import servicesConfig from '../config/servicesConfig.json';

export const slugify = (value = '') => {
  return value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

export const getCategories = () => servicesConfig.categories;

export const getCategoryById = (categoryId) => {
  return getCategories().find((category) => category.id === categoryId) || null;
};

export const getCategoryServices = (category) => {
  if (!category) {
    return [];
  }

  if (category.services) {
    return category.services.map((service) => ({
      service,
      subcategoryTitle: null,
      serviceSlug: slugify(service.title)
    }));
  }

  if (category.subcategories) {
    return category.subcategories.flatMap((subcategory) =>
      subcategory.services.map((service) => ({
        service,
        subcategoryTitle: subcategory.title,
        serviceSlug: slugify(service.title)
      }))
    );
  }

  return [];
};

export const getServiceBySlugs = (categoryId, serviceSlug) => {
  const category = getCategoryById(categoryId);
  if (!category) {
    return null;
  }

  const services = getCategoryServices(category);
  const match = services.find((entry) => entry.serviceSlug === serviceSlug);

  if (!match) {
    return null;
  }

  return {
    category,
    ...match,
    allServices: services
  };
};